import * as OptionModule from '@effect/data/Option';
import * as FunctionModule from '@effect/data/Function';
import * as ReadonlyArrayModule from '@effect/data/ReadonlyArray';
export const O = OptionModule;
export const F = FunctionModule;
export const pipe = F.pipe;
export const RA = ReadonlyArrayModule;
//# sourceMappingURL=EffectExports.js.map